import { calculateMm } from 'editor/src/util/calculateDPI';

interface AreaSize {
  width: number;
  height: number;
}

interface SizeMm {
  width: number;
  height: number;
}

// Physical size of an asset printed at the given DPI, proportionally scaled down when it
// would not fit the sheet's content area. Returns undefined for unusable inputs (unknown
// pixel dimensions or a degenerate area).
function getImageSizeAtDpiMm(
  imagePxWidth: number,
  imagePxHeight: number,
  dpi: number,
  area: AreaSize,
): SizeMm | undefined {
  if (imagePxWidth <= 0 || imagePxHeight <= 0 || dpi <= 0 || area.width <= 0 || area.height <= 0) {
    return undefined;
  }

  const targetWidth = calculateMm(imagePxWidth, dpi);
  const targetHeight = calculateMm(imagePxHeight, dpi);
  const scale = Math.min(1, area.width / targetWidth, area.height / targetHeight);

  return { width: targetWidth * scale, height: targetHeight * scale };
}

export default getImageSizeAtDpiMm;
